import PromotionSwitcher from "./PromotionSwitcher";
import {Link} from "react-router-dom";
import {PromotionInterface} from "../../../interfaces/news/PromotionInterface";
import {PromotionTabs} from "./Promotions";

export default function PromotionsList({promotions, tab, setTab}: {promotions: PromotionInterface[], tab: PromotionTabs, setTab: (tab: PromotionTabs) => void}) {
    return (<div className="row">
        <div className="col">
            <h1 className="stocks__title f-exp">Акции</h1>

            <div className="stocks__tabs">
                <PromotionSwitcher tab={tab} setTab={setTab}/>
            </div>
            <div className="tab-content">
                <div className={"tab-pane show active"}>
                    <div className="stocks__list row">
                        {promotions.map((promotion) => (
                            <div className="col-lg-4" key={promotion.id}>
                                <div className="stocks__block">
                                    <picture>
                                        <source srcSet={promotion.image} media="(max-width: 992px)"/>
                                        <img src={promotion.image} alt={promotion.image}/>
                                    </picture>
                                    {/* <h3 className="f-exp">{post.title}</h3> */}
                                    {/* <p>{post.body}</p> */}
                                    <Link className="btn btn-primary" to={"/promotion/" + promotion.id}>
                                        Подробнее
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>)
}